import { createRoot } from 'react-dom/client';

// Import polyfills first
import './lib/polyfills.ts';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

// Detect iOS Safari for safe-area workarounds
// iOS Safari doesn't properly report safe-area-inset-top in PWA mode
const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
if (isIOSSafari) {
  document.documentElement.classList.add('ios-safari');
}

// Configure status bar for mobile
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

if (Capacitor.isNativePlatform()) {
  // Add class to document for native-specific CSS
  document.documentElement.classList.add('native-app');
  
  // Capacitor Style enum:
  // Style.Dark = "Light text for dark backgrounds"  
  // Style.Light = "Dark text for light backgrounds"
  
  const updateStatusBar = () => {
    // Check the actual applied theme class on document root
    const isDark = document.documentElement.classList.contains('dark');
    
    // Light background (#faf7f0) → needs dark icons → Style.Light
    // Dark background (#201713) → needs light icons → Style.Dark
    StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light }).catch(() => {});
    StatusBar.setBackgroundColor({ color: isDark ? '#201713' : '#faf7f0' }).catch(() => {});
  };
  
  // Set initial status bar
  updateStatusBar();
  
  // Watch for theme class changes on document root using MutationObserver
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        updateStatusBar();
      }
    });
  });
  
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
